import type { PhoneCallAction } from '../../../api/types';
import type { LangFn } from '../../../hooks/useLang';

import { formatTimeDuration } from '../../../util/date/dateFormat';

// Mirrors tdesktop `Data::ComputeCallData`: an outgoing call that never connected is "cancelled",
// an incoming one is "missed" (not picked up) or "declined" (rejected / busy).
export function getPhoneCallReasonKey(phoneCall: PhoneCallAction) {
  const {
    isOutgoing, isVideo, reason, duration,
  } = phoneCall;
  const video = isVideo ? 'Video' : '';

  if (!duration) {
    if (isOutgoing) {
      return reason === 'busy' ? `CallMessage${video}OutgoingDeclined` : `CallMessage${video}OutgoingMissed`;
    }

    return reason === 'missed' || reason === 'disconnect'
      ? `CallMessage${video}IncomingMissed`
      : `CallMessage${video}IncomingDeclined`;
  }

  return isOutgoing ? `CallMessage${video}Outgoing` : `CallMessage${video}Incoming`;
}

export function formatPhoneCallDuration(lang: LangFn, duration?: number) {
  return duration ? formatTimeDuration(lang, duration) : undefined;
}

export function getPhoneCallSummaryText(lang: LangFn, phoneCall: PhoneCallAction) {
  const reasonText = lang(getPhoneCallReasonKey(phoneCall));
  const duration = formatPhoneCallDuration(lang, phoneCall.duration);

  return duration ? lang('CallMessageWithDuration', [reasonText, duration]) : reasonText;
}
